import PropertySheetContext from './PropertySheetContext';
import { TargetVersion } from '../Shared';

export default abstract class PropertySheetEntry {
    abstract render(context: PropertySheetContext): HTMLElement;

    constructor(readonly targetVersion: TargetVersion) {}
}
